'use client';

export const styles = {
    shell: 'flex flex-col z-(--z-index-floating-panels) origin-(--trigger-anchor-point) will-change-transform outline-hidden',
    base: 'flex flex-col flex-1 min-h-0 overflow-hidden rounded-xl bg-primary shadow-2xl outline-hidden',
    body: 'min-h-0 flex-1 overflow-y-auto px-1.5 py-1 outline-hidden focus:outline-none',
    header: 'shrink-0 border-b border-tertiary px-md py-md',
    footer: 'shrink-0 border-t border-tertiary px-xl py-md',
    search: {
        container: 'w-full',
        input: 'rounded-sm',
    },
    motion: {
        entering: 'duration-150 ease-out animate-in fade-in',
        exiting: 'duration-100 ease-in animate-out fade-out',
    },
} as const;
